import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { useLang } from "../../contexts/LanguageContext";

const AdminLogin = () => {
  const { login, user } = useAuth();
  const { t, lang, setLang } = useLang();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@larcraftmedya.com");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => { if (user) nav("/admin", { replace: true }); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await login(email, password);
      nav("/admin", { replace: true });
    } catch (er) {
      setErr(er?.response?.data?.detail || t.admin.invalid);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grain" data-testid="admin-login" style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 24, background: "radial-gradient(ellipse at center, rgba(139,32,53,0.15), var(--rich-black))" }}>
      <div style={{ width: "100%", maxWidth: 460, padding: "56px 44px", background: "rgba(17,17,17,0.85)", border: "1px solid rgba(201,151,58,0.3)", backdropFilter: "blur(20px)" }} className="corner-deco">
        <div className="flex justify-between" style={{ marginBottom: 36 }}>
          <div className="font-display" style={{ fontSize: "2rem", color: "var(--warm-off-white)", fontWeight: 300 }}>Larcraft<span style={{ color: "var(--gold)" }}>.</span></div>
          <div className="font-mono" style={{ fontSize: "0.7rem", letterSpacing: "0.15em" }}>
            <button onClick={() => setLang("tr")} style={{ background: "transparent", border: "none", color: lang === "tr" ? "var(--gold)" : "rgba(248,244,240,0.4)", padding: "4px 6px" }}>TR</button>
            <span style={{ color: "rgba(248,244,240,0.25)" }}>|</span>
            <button onClick={() => setLang("en")} style={{ background: "transparent", border: "none", color: lang === "en" ? "var(--gold)" : "rgba(248,244,240,0.4)", padding: "4px 6px" }}>EN</button>
          </div>
        </div>
        <div className="font-mono" style={{ fontSize: "0.7rem", letterSpacing: "0.2em", color: "var(--gold)", textTransform: "uppercase", marginBottom: 12 }}>Admin</div>
        <h1 className="font-display" style={{ fontSize: "2.25rem", fontWeight: 300, color: "var(--warm-off-white)", lineHeight: 1.1, marginBottom: 8 }}>
          {t.admin.loginTitle}
        </h1>
        <p style={{ color: "rgba(248,244,240,0.6)", marginBottom: 36, fontSize: "0.9rem" }}>{t.admin.loginSubtitle}</p>
        <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: 24 }}>
          <div>
            <label className="font-mono" style={{ fontSize: "0.65rem", letterSpacing: "0.2em", color: "var(--gold)", textTransform: "uppercase" }}>{t.admin.email}</label>
            <input data-testid="admin-login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-line" style={{ marginTop: 8 }} />
          </div>
          <div>
            <label className="font-mono" style={{ fontSize: "0.65rem", letterSpacing: "0.2em", color: "var(--gold)", textTransform: "uppercase" }}>{t.admin.password}</label>
            <input data-testid="admin-login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="input-line" style={{ marginTop: 8 }} />
          </div>
          {err && <p data-testid="admin-login-error" style={{ color: "var(--bordeaux-light)", fontSize: "0.85rem" }}>{err}</p>}
          <button data-testid="admin-login-submit" type="submit" disabled={loading} className="font-mono" style={{ padding: "16px 24px", background: "var(--bordeaux)", color: "var(--warm-off-white)", border: "none", textTransform: "uppercase", letterSpacing: "0.2em", fontSize: "0.75rem", cursor: loading ? "default" : "pointer", marginTop: 8 }}>
            {loading ? t.admin.loggingIn : t.admin.login}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
